module.exports = __webpack_public_path__ + "static/media/e.f2049a7a.png";